import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { buyThirdPersonSchema } from './buyThirdPersonSchema';
import {
  DSelect,
  HDatePicker,
  HInput,
  HookForm,
  HSelect,
  HTextarea,
} from '../../../../../validation/HForm';
import { documentTypes, defaultCountry } from '../../../../../helpers/data-constants';
import { getCountry } from '../../../../../redux/actions/clientAddAction';
import { Message } from '../../..';

import './buyThirdPersonModal.scss';
import moment from 'moment';

const defaultValue = {
  authority: '',
  baseClosure: '',
  citizenship: defaultCountry,
  documentNumber: '',
  documentType: documentTypes.residency[0],
  firstName: '',
  lastName: '',
  middleName: '',
  personalNumber: '',
  startDate: '',
};

export const LayoutBuyThirdPersonModal = ({ onSubmitBuyThirdPerson, closeBuyThirdPersonModal }) => {
  const { commonError, country, isLoading } = useSelector(({ clientAdd }) => clientAdd);
  const dispatch = useDispatch();

  const onSubmit = (data) => {
    onSubmitBuyThirdPerson({
      ...data,
      citizenship: data.citizenship.label,
      startDate: moment(data.startDate).format('YYYY-MM-DD'),
    });
  };

  const handleClose = () => {
    closeBuyThirdPersonModal();
  };

  const handleOptions = (syl, action) => {
    if (action.action === 'input-change') dispatch(getCountry(syl));
  };

  return (
    <>
      {commonError && <Message type="error" text={commonError} />}
      <HookForm
        onSubmit={onSubmit}
        validationSchema={buyThirdPersonSchema}
        defaultValues={defaultValue}>
        <div className="modal-header">
          <h2>Информация о третьем лице</h2>
        </div>
        <div className="modal-body">
          <div className="form-row">
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="lastName">
                  Фамилия
                </label>
                <div className="form-element-data">
                  <HInput h="true" className="input" type="text" name="lastName" id="lastName" />
                </div>
              </div>
            </div>
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="firstName">
                  Имя
                </label>
                <div className="form-element-data">
                  <HInput h="true" className="input" type="text" name="firstName" id="firstName" />
                </div>
              </div>
            </div>
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="middleName">
                  Отчество
                </label>
                <div className="form-element-data">
                  <HInput
                    h="true"
                    className="input"
                    type="text"
                    name="middleName"
                    id="middleName"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="form-row">
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="citizenship">
                  Гражданство
                </label>
                <div className="form-element-data combobox">
                  <DSelect
                    h="true"
                    name="citizenship"
                    isLoading={isLoading}
                    options={country}
                    handleOptions={handleOptions}
                    placeholder="Введите страну"
                  />
                </div>
              </div>
            </div>
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="documentType">
                  Вид документа
                </label>
                <div className="form-element-data">
                  <HSelect
                    h="true"
                    className="input"
                    type="text"
                    name="documentType"
                    id="documentType"
                    options={['', ...documentTypes.residency, documentTypes.another[1]]}
                  />
                </div>
              </div>
            </div>
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="personalNumber">
                  Идентификационный номер
                </label>
                <div className="form-element-data">
                  <HInput
                    h="true"
                    className="input"
                    type="text"
                    name="personalNumber"
                    id="personalNumber"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="form-row">
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="startDate">
                  Дата выдачи
                </label>
                <div className="form-element-data date">
                  <HDatePicker h="true" className="input" name="startDate" id="startDate" />
                </div>
              </div>
            </div>
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="authority">
                  Орган, выдавший документ
                </label>
                <div className="form-element-data">
                  <HInput h="true" className="input" type="text" name="authority" id="authority" />
                </div>
              </div>
            </div>
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="documentNumberClosure">
                  Номер документа
                </label>
                <div className="form-element-data">
                  <HInput
                    h="true"
                    className="input"
                    type="text"
                    name="documentNumberClosure"
                    id="documentNumberClosure"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="form-row">
            <div className="form-row-item">
              <div className="form-element">
                <label className="form-element-label" htmlFor="whoHasTo">
                  Кем приходится
                </label>
                <div className="form-element-data">
                  <HInput h="true" className="input" type="text" name="whoHasTo" id="whoHasTo" />
                </div>
              </div>
            </div>
          </div>

          <div className="form-row full-width">
            <div className="form-row-item full-width">
              <div className="form-element full-width">
                <label className="form-element-label" htmlFor="baseClosure">
                  Основание
                </label>
                <div className="form-element-data full-width">
                  <HTextarea
                    h="true"
                    className="input full-width"
                    type="text"
                    name="baseClosure"
                    id="baseClosure"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer flex-space-between">
          <button className="button">Сохранить</button>
          <button className="button-light" onClick={handleClose}>
            Отменить
          </button>
        </div>
      </HookForm>
    </>
  );
};
